export const LOAN_STAGES = [
  "Form Submitted to Bank",
  "Form Accepted",
  "Loan Approved",
];

export const STAGE_ORDER = [
  "Registration Done",
  "Phone Verification Done",
  "Bank & Finance",
  "Sent to Store",
  "Installation Done",
  "Plant Activated",
  "Subsidy Registration Completed",
  "Completed",
];
